// Generated by CoffeeScript 1.6.3
/**
 * Responsive tables
 * Inspired by:
 * http://codepen.io/anon/pen/QwPVNW
 * https://css-tricks.com/examples/ResponsiveTables/responsive.php
 * http://codepen.io/pixelchar/pen/rfuqK
*/

itsoftApp.createModule("responsiveTables", function() {
  var dAttrLabel, tables;
  tables = $("table");
  if (!tables.length) {
    return false;
  }
  dAttrLabel = "data-label";
  tables.each(function() {
    var labels, table, th, thead;
    table = $(this);
    thead = table.find("thead");
    th = thead.find("th, td");
    labels = [];
    th.each(function() {
      return labels.push($(this).text().trim());
    });
    return table.find("tr").each(function() {
      var tr;
      tr = $(this);
      return tr.find("td").each(function(index) {
        var td;
        td = $(this);
        if (!td.attr(dAttrLabel)) {
          return td.attr(dAttrLabel, labels[index]);
        }
      });
    });
  });
  if (DEBUG && typeof describe === "function") {
    return describe("[module responsiveTables]", function() {
      it("labels array must be non-empty", function() {
        return tables.each(function() {
          var labels, table, th, thead;
          table = $(this);
          thead = table.find("thead");
          th = thead.find("th, td");
          labels = [];
          th.each(function() {
            return labels.push($(this).text().trim());
          });
          expect(labels).to.be.an("array");
          return expect(labels.length).to.be.above(0);
        });
      });
      return it("must add " + dAttrLabel + " attribute to each table cell (inside <tbody>)", function() {
        return tables.find("tbody td").each(function() {
          var td;
          td = $(this);
          return expect(td.attr(dAttrLabel)).to.not.be.undefined;
        });
      });
    });
  }
});

/*
//@ sourceMappingURL=responsiveTables.map
*/
